/*
 * Jersey cart bundle collapser — groups lines by _TRIKOT into one main line with the
 * bundle total + breakdown, hides the child add-ons; runs on cart page and drawer
 */
(function () {
  'use strict';

  // Breakdown spacing in CSS not inline, so the mobile override can win
  (function injectStyle() {
    if (document.getElementById('jp-bundle-style')) return;
    var s = document.createElement('style');
    s.id = 'jp-bundle-style';
    s.textContent =
      '.jp-bundle-breakdown{margin-top:4px}' +
      '@media (max-width:749px){.jp-bundle-breakdown{margin-top:8px}}';
    (document.head || document.documentElement).appendChild(s);
  })();

  function money(cents) {
    try {
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
        return window.Shopify.formatMoney(cents, window.moneyFormat);
      }
    } catch (e) { }
    return 'CHF ' + (Number(cents) / 100).toFixed(2);
  }

  function getCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) {
      return r.json();
    });
  }

  function findRow(item) {
    var sels = [
      '[data-cart-item="' + item.key + '"]',
      '[data-key="' + item.key + '"]',
      '.cart-item[data-variant-id="' + item.variant_id + '"]',
      '.cart-item-card[data-variant-id="' + item.variant_id + '"]'
    ];
    for (var i = 0; i < sels.length; i++) {
      var el = document.querySelector(sels[i]);
      if (el) return el;
    }
    // Cart drawer: rows are `.cart-items-wrapper > [data-line="<1-based index>"]`.
    if (typeof item._idx === 'number') {
      var dr = document.querySelector('.cart-items-wrapper > [data-line="' + (item._idx + 1) + '"]');
      if (dr) return dr;
    }
    return null;
  }

  function setPrice(row, cents) {
    var els = row.querySelectorAll(
      '.cart-item-final-price, .cart-item-price-unit, .cart-item__price, [class*="final-price"], .cart-item__prices .price'
    );
    for (var i = 0; i < els.length; i++) els[i].textContent = money(cents);
  }

  function process(cart) {
    if (!cart || !cart.items) return;

    // Refresh the header cart badge to exclude add-on (child) lines on initial
    // page load (the theme only recomputes it on cart changes).
    try {
      if (
        typeof getDisplayItemCount === 'function' &&
        typeof applyDisplayCountToBadges === 'function'
      ) {
        applyDisplayCountToBadges(getDisplayItemCount(cart));
      }
    } catch (e) { }

    var groups = {};
    cart.items.forEach(function (it, idx) {
      it._idx = idx;
      var t = it.properties && it.properties._TRIKOT;
      if (!t) return;
      (groups[t] = groups[t] || []).push(it);
    });

    Object.keys(groups).forEach(function (t) {
      var items = groups[t];
      var main = items.filter(function (x) {
        return x.properties._bundle_type === 'main';
      })[0];
      var children = items.filter(function (x) {
        return x.properties._bundle_type === 'child';
      });
      if (!main || !children.length) return;

      var mainRow = findRow(main);
      if (!mainRow) return;

      var total = main.final_line_price;
      var addonTotal = 0;
      children.forEach(function (c) {
        var row = findRow(c);
        if (row) row.style.display = 'none';
        total += c.final_line_price;
        addonTotal += c.final_line_price;
      });

      // One combined "Personalisierung" line rather than itemising Name/Nummer: a name-only
      // order otherwise showed a confusing "Nummer CHF 10.00" (the auto "no number"
      // placeholder). The entered value itself still shows as the "Individuell - Name/Nummer"
      // property on the line.
      var parts = ['Trikot ' + money(main.final_line_price)];
      if (addonTotal > 0) parts.push('Personalisierung ' + money(addonTotal));

      // Show the bundle total on the jersey line.
      setPrice(mainRow, total);

      // Breakdown note (refreshed each run to stay in sync) — its own full-width
      // line, right-aligned, below the normal quantity/price row.
      var old = mainRow.querySelector('.jp-bundle-breakdown');
      if (old) old.remove();
      var note = document.createElement('div');
      note.className = 'jp-bundle-breakdown';
      note.textContent = '(' + parts.join(' + ') + ')';
      note.style.cssText =
        'flex:0 0 100%;width:100%;font-size:12px;opacity:.7;line-height:1.3;text-align:right;';
      var anchor =
        mainRow.querySelector('.cart-item-final-price') ||
        mainRow.querySelector('.cart-item-price-unit') ||
        mainRow.querySelector('.cart-item-price') ||
        mainRow;
      // Keep the normal row (quantity left, price right); just let it wrap so the
      // breakdown drops onto its own line.
      var priceBox = anchor.parentNode || mainRow;
      priceBox.style.display = 'flex';
      priceBox.style.flexWrap = 'wrap';
      priceBox.style.alignItems = 'center';
      priceBox.style.justifyContent = 'space-between';
      priceBox.appendChild(note);

      mainRow.setAttribute('data-jp-bundle-main', '1');
    });
  }

  var timer = null;
  function run() {
    getCart().then(process).catch(function () { });
  }
  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(run, 150);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  // Re-run when cart line items are (re)rendered — e.g. the drawer opening.
  var mo = new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      var added = muts[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var n = added[j];
        if (n.nodeType !== 1) continue;
        var SEL =
          '[data-cart-item], .cart-item, .cart-item-card, .cart-items-wrapper, [data-line], .cart-item-price-unit';
        var isItem =
          (n.matches && n.matches(SEL)) || (n.querySelector && n.querySelector(SEL));
        if (isItem) {
          schedule();
          return;
        }
      }
    }
  });
  mo.observe(document.body, { childList: true, subtree: true });
  document.addEventListener('cart:updated', schedule);
  document.addEventListener('cart:refresh', schedule);
})();
